import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import Chip from '@material-ui/core/Chip'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/ErrorOutline'

const useStyles = makeStyles((theme) => ({
  highConfidenceBadge: {
    backgroundColor: '#C2E9D4',
    color: '#33895B',
    fontSize: '10px',
    height: '24px',
    fontWeight: 600,
    border: '0.5px solid #33895B',
    marginLeft: theme.spacing(0.25),
    '& .MuiChip-icon': {
      color: '#33895B',
      fontSize: '16px',
    },
  },
  mediumConfidenceBadge: {
    backgroundColor: '#FDF9DC',
    color: '#E6AC3E',
    fontSize: '10px',
    height: '24px',
    fontWeight: 600,
    border: '0.5px solid #E6AC3E',
    marginLeft: theme.spacing(0.25),
    '& .MuiChip-icon': {
      color: '#E6AC3E',
      fontSize: '16px',
    },
  },
  lowConfidenceBadge: {
    backgroundColor: '#FFE3E3',
    color: '#CA3030',
    fontSize: '10px',
    height: '24px',
    fontWeight: 600,
    border: '0.5px solid #CA3030',
    marginLeft: theme.spacing(0.25),
    '& .MuiChip-icon': {
      color: '#CA3030',
      fontSize: '16px',
    },
  },
}))

const ConfidenceBadge = ({ confidence }) => {
  const classes = useStyles()
  const confidenceValue = Math.round(confidence)
  if (confidenceValue >= 97) {
    return (
      <Chip
        icon={<CheckCircleIcon />}
        label="Confiança Alta"
        className={classes.highConfidenceBadge}
        size="small"
      />
    )
  }

  if (confidenceValue >= 94) {
    return (
      <Chip
        icon={<ErrorIcon />}
        label="Confiança Média"
        className={classes.mediumConfidenceBadge}
        size="small"
      />
    )
  }

  return (
    <Chip
      icon={<ErrorIcon />}
      label="Confiança Baixa"
      className={classes.lowConfidenceBadge}
      size="small"
    />
  )
}

ConfidenceBadge.propTypes = {
  confidence: PropTypes.number,
}

ConfidenceBadge.defaultProps = {
  confidence: 0.0,
}

export default ConfidenceBadge
